import { useTranslation } from 'react-i18next';
import ConsultantCard from '../components/ConsultantCard';
import { useCMS, pickLoc, consultantField, activeConsultants } from '../context/CMSContext';
import { useSeo, breadcrumb } from '../lib/seo';
import { resolveConsultantImage } from '../lib/images';

const Consultants = () => {
  const { t } = useTranslation();
  const { cms, lang } = useCMS();

  const seo = cms.seo.pages.consultants;

  useSeo({
    title: pickLoc(seo.title, lang),
    description: pickLoc(seo.description, lang),
    keywords: pickLoc(seo.keywords, lang),
    path: '/consultants',
    jsonLd: breadcrumb([
      { name: '首頁', path: '/' },
      { name: t('nav.consultants'), path: '/consultants' },
    ]),
  });

  const consultants = activeConsultants(cms);

  return (
    <div className="bg-gray-50 min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6 font-serif">{t('team.title')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('team.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {consultants.map((consultant) => (
            <ConsultantCard
              key={consultant.id}
              id={consultant.id}
              name={consultantField(consultant, 'name', lang)}
              role={consultantField(consultant, 'title', lang)}
              tags=""
              bio={consultantField(consultant, 'description', lang)}
              image={resolveConsultantImage(consultant.imageUri)}
              ctaText={t('team.cta')}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Consultants;
